import React from 'react';
import classNames from 'classnames';
import styles from './no-rotations.module.scss';
import { BackgroundVector } from 'src/images/panda';
import { PandaResting } from 'shared/images/characters';
import { getLang } from 'shared/store/selectors/lang.selector';
import { useSelector } from 'react-redux';
import { isAccountAdmin } from 'shared/store/selectors/auth.selector';
import { AddNewRotation } from '../components/rotations-list-add-rotations.component';

const NoRotations = () => {
  const lang = useSelector(getLang('ROTATIONS_EMPTY_STATE'));
  const canCreateRotation = useSelector(isAccountAdmin);

  let title = lang.TITLE;
  let description = lang.DESCRIPTION;

  if (canCreateRotation) {
    title = lang.TITLE_ADMIN;
    description = lang.DESCRIPTION_ADMIN;
  }

  return (
    <div className={classNames('new-design-system', styles.root)}>
      <div style={{ backgroundImage: `url(${BackgroundVector})` }} className={styles.background} />
      <div className={styles.container}>
        <img src={PandaResting} className={styles.panda} alt="No Rotations" />
        <div className={styles.content}>
          <h1>{title}</h1>
          <p>{description}</p>
          {canCreateRotation && (
            <AddNewRotation
              CTA={lang.CREATE_FIRST_ROTATION}
              createSchedule
              buttonStyle={{
                type: 'primary',
                size: 'large',
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export { NoRotations };
